export const LOAD = 'ethstats/nodeHistory/LOAD';
export const LOAD_SUCCESS = 'ethstats/nodeHistory/LOAD_SUCCESS';
export const LOAD_FAIL = 'ethstats/nodeHistory/LOAD_FAIL';
export const LOAD_NODENAME = 'ethstats/nodeHistory/LOAD_NODENAME';
export const CLEAR_DATA = 'ethstats/nodeHistory/CLEAR_DATA';
export const LOAD_COUNT = 'ethstats/nodeHistory/LOAD_COUNT';
export const LOAD_COUNT_SUCCESS = 'ethstats/nodeHistory/LOAD_COUNT_SUCCESS';
export const LOAD_COUNT_FAIL = 'ethstats/nodeHistory/LOAD_COUNT_FAIL';
